import { cn } from '@/lib/utils';

const STATUS_STYLES: Record<string, string> = {
  Active: 'bg-emerald-50 text-emerald-700 ring-emerald-600/20',
  Inactive: 'bg-gray-100 text-gray-600 ring-gray-500/20',
  Demo: 'bg-blue-50 text-blue-700 ring-blue-600/20',
  Pilot: 'bg-amber-50 text-amber-700 ring-amber-600/20',
  'Kim Internal': 'bg-violet-50 text-violet-700 ring-violet-600/20',
  Partnership: 'bg-teal-50 text-teal-700 ring-teal-600/20',
  Junk: 'bg-red-50 text-red-700 ring-red-600/20'
};

export function StatusBadge({ status }: { status: string | null }) {
  if (!status) {
    return <span className='text-xs text-muted-foreground'>—</span>;
  }
  const style = STATUS_STYLES[status] ?? 'bg-gray-100 text-gray-600 ring-gray-500/20';
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-inset',
        style
      )}
    >
      {status}
    </span>
  );
}
